var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9618 12.5991V21.0191C11.9618 22.1347 11.0574 23.039 9.94183 23.039V23.039C8.82624 23.039 7.92188 22.1347 7.92188 21.0191V20.0349",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9629 1.03906L11.9629 2.39692",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9229 12.0613L20.9229 11.7133C20.9229 6.76454 16.911 2.75274 11.9622 2.75274C7.01344 2.75274 3.00163 6.76454 3.00163 11.7133L3.00163 12.0613L6.04 10.7109C6.63524 10.4464 6.93286 10.3141 7.23106 10.2637C7.72847 10.1796 8.23973 10.2543 8.69223 10.4773C8.9635 10.611 9.21079 10.823 9.70535 11.2469L9.70536 11.2469C10.3618 11.8096 10.69 12.0909 11.0424 12.2372C11.6313 12.4815 12.2932 12.4815 12.882 12.2372C13.2345 12.0909 13.5627 11.8096 14.2191 11.2469L14.2191 11.2469C14.7137 10.823 14.961 10.611 15.2323 10.4773C15.6848 10.2543 16.196 10.1796 16.6934 10.2637C16.9916 10.3141 17.2892 10.4464 17.8845 10.7109L20.9229 12.0613Z",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.10e398431e21ea356f4b410ebed3ff3b.svg";
export { ForwardRef as ReactComponent };